import type { Campsite } from "@/types/campsite";
import camp1 from "../assets/camp_1.png";
import camp2 from "../assets/camp_2.png";
import camp3 from "../assets/camp_3.png";
import camp4 from "../assets/camp_4.png";

// Facility Icons
import tentCampingIcon from "../assets/facility/Tent Camping Area.svg";
import woodenCabinIcon from "../assets/facility/Wooden Cabin.svg";
import restroomIcon from "../assets/facility/Rest Room.svg";
import bbqPitsIcon from "../assets/facility/BBQ pits.svg";
import picnicDecksIcon from "../assets/facility/Picnic Decks.svg";
import activityLawnIcon from "../assets/facility/Activity Lawn.svg";
import onSiteShopIcon from "../assets/facility/On Site Shop.svg";
import firstAidIcon from "../assets/facility/First Aid Station.svg";


export const mockCampsites: Campsite[] = [
  {
    id: '1',
    name: 'Lau Shui Heung Campsite',
    description: 'It is located on the north-east part of Lung Shan. The small beautiful reservoir was used to irrigate nearby field.',
    location: 'Lung Shan',
    distance: '3km',
    occupancy: {
      current: 12,
      total: 30,
      percentage: 40
    },
    rating: 94,
    images: [
      camp1,
      camp2,
      camp3
    ],
    facilities: [
      { name: 'Tent Camping Area', icon: tentCampingIcon, available: true },
      { name: 'Wooden Cabins', icon: woodenCabinIcon, available: true },
      { name: 'Restrooms & Showers', icon: restroomIcon, available: true },
      { name: 'BBQ Pits', icon: bbqPitsIcon, available: true },
      { name: 'Picnic Decks', icon: picnicDecksIcon, available: true },
      { name: 'Activity Lawn', icon: activityLawnIcon, available: true },
      { name: 'On-site Shop', icon: onSiteShopIcon, available: true },
      { name: 'First Aid Station', icon: firstAidIcon, available: true }
    ],
    coordinates: { lat: 22.5, lng: 114.2 }
  },
  {
    id: '2',
    name: 'Tung Ping Chau Campsite',
    description: 'A beautiful coastal campsite with stunning ocean views and excellent hiking trails nearby.',
    location: 'Tung Ping Chau',
    distance: '15km',
    occupancy: {
      current: 28,
      total: 30,
      percentage: 94
    },
    rating: 89,
    images: [
      camp2,
      camp4
    ],
    facilities: [
      { name: 'Tent Camping Area', icon: tentCampingIcon, available: true },
      { name: 'Restrooms & Showers', icon: restroomIcon, available: true },
      { name: 'BBQ Pits', icon: bbqPitsIcon, available: true },
      { name: 'Activity Lawn', icon: activityLawnIcon, available: true },
      { name: 'First Aid Station', icon: firstAidIcon, available: true }
    ],
    coordinates: { lat: 22.6, lng: 114.3 }
  },
  {
    id: '3',
    name: 'Tai Mei Tuk Campsite',
    description: 'Family-friendly campsite with modern facilities and easy access to water activities.',
    location: 'Tai Po',
    distance: '8km',
    occupancy: {
      current: 18,
      total: 25,
      percentage: 72
    },
    rating: 91,
    images: [
      camp3,
      camp1
    ],
    facilities: [
      { name: 'Tent Camping Area', icon: tentCampingIcon, available: true },
      { name: 'Wooden Cabins', icon: woodenCabinIcon, available: true },
      { name: 'Restrooms & Showers', icon: restroomIcon, available: true },
      { name: 'BBQ Pits', icon: bbqPitsIcon, available: true },
      { name: 'Picnic Decks', icon: picnicDecksIcon, available: true },
      { name: 'On-site Shop', icon: onSiteShopIcon, available: true },
      { name: 'First Aid Station', icon: firstAidIcon, available: true }
    ],
    coordinates: { lat: 22.4, lng: 114.1 }
  },
  {
    id: '4',
    name: 'Sai Kung East Country Park',
    description: 'Remote wilderness campsite perfect for experienced campers seeking adventure.',
    location: 'Sai Kung',
    distance: '12km',
    occupancy: {
      current: 25,
      total: 25,
      percentage: 100
    },
    rating: 87,
    images: [
      camp4
    ],
    facilities: [
      { name: 'Tent Camping Area', icon: '/src/assets/facility/Tent Camping Area.svg', available: true },
      { name: 'Restrooms & Showers', icon: '/src/assets/facility/Rest Room.svg', available: true },
      { name: 'Activity Lawn', icon: '/src/assets/facility/Activity Lawn.svg', available: true },
      { name: 'First Aid Station', icon: '/src/assets/facility/First Aid Station.svg', available: true }
    ],
    coordinates: { lat: 22.3, lng: 114.4 }
  }
];